import React from 'react';
import GameImage from '@/pages/home/components/GameImage';
import { IGameIcon } from '../../interfaces';
import './index.scss';

const GameIcon: React.FC<IGameIcon> = (props) => {
  const { entityType, src } = props;

  return (
    <div className={`dbi-benchmark-selector-gameicon ${entityType}-img-container`}>
      <GameImage imageType={entityType} hasLoading={true} src={src} />
    </div>
  );
};

export default GameIcon;
